import {Brick, registerBrick} from 'olympe';

export default class ObjectToJSON extends Brick {
    /**
     * Executed every time an input (object) gets updated.
     * Note that this method will _not_ be executed if an input value is undefined.
     *
     * @protected
     * @param {BrickContext} context
     * @param {*} object
     * @param {function(string)} setJSON
     */
    update(context, [object], [setJSON]) {
        try {
            setJSON(JSON.stringify(object));
        } catch (e) {
            console.error(`Could not parse Object : ${e}`);
        }
    }
}

registerBrick('017e56748825ff1b5de3', ObjectToJSON);
